import { WidgetPreliminaryRiskAssessmentValueV0 } from './models/widget-preliminary-risk-assessment-value-v0';
import {
  WidgetPreliminaryRiskAssessmentCheckedValueV0,
  WidgetPreliminaryRiskAssessmentPreviewV0,
} from './models/widget-preliminary-risk-assessment-preview-v0';

export class WidgetPreliminaryRiskAssessmentV0Utils {
  static queryResponseToValutationRow(
    queryResponse: unknown[],
    mapping: {},
    value: WidgetPreliminaryRiskAssessmentValueV0[]
  ): WidgetPreliminaryRiskAssessmentPreviewV0[] {
    const keys = Object.keys(mapping);
    const response: WidgetPreliminaryRiskAssessmentPreviewV0[] = [];
    queryResponse.forEach((q: unknown) => {
      const obj = {};
      keys.forEach((outputKey: string) => {
        obj[outputKey] = q[mapping[outputKey]];
      });
      response.push(obj as WidgetPreliminaryRiskAssessmentPreviewV0);
    });

    return this.valutationRowCheckValue(response, value);
  }

  static getValidValue(
    value: WidgetPreliminaryRiskAssessmentValueV0[],
    validValues: WidgetPreliminaryRiskAssessmentPreviewV0[]
  ) {
    const validValue = [];
    if (value && value?.length > 0 && validValues?.length > 0) {
      const validValuesUUID = validValues.map((v) => v.uuid);
      value.forEach(
        (currentSavedValue: WidgetPreliminaryRiskAssessmentValueV0) => {
          if (validValuesUUID.includes(currentSavedValue.uuid)) {
            validValue.push(currentSavedValue);
          }
        }
      );
    }
    return validValue;
  }

  private static valutationRowCheckValue(
    checkBox: WidgetPreliminaryRiskAssessmentPreviewV0[],
    value: WidgetPreliminaryRiskAssessmentValueV0[]
  ): WidgetPreliminaryRiskAssessmentPreviewV0[] {
    if (value?.length) {
      checkBox.forEach((c: WidgetPreliminaryRiskAssessmentPreviewV0) => {
        const currentValue = value.find(
          (v: WidgetPreliminaryRiskAssessmentValueV0) => v.uuid === c.uuid
        );
        if (currentValue) {
          c.checked = currentValue.selected
            ? WidgetPreliminaryRiskAssessmentCheckedValueV0.TRUE
            : WidgetPreliminaryRiskAssessmentCheckedValueV0.FALSE;
          c.editable =
            currentValue &&
            currentValue.editable !== undefined &&
            currentValue.editable !== null
              ? currentValue.editable
              : true;
        } else {
          c.checked = WidgetPreliminaryRiskAssessmentCheckedValueV0.NONE;
          c.editable = true;
        }
      });
    } else {
      checkBox.forEach((c: WidgetPreliminaryRiskAssessmentPreviewV0) => {
        c.checked = WidgetPreliminaryRiskAssessmentCheckedValueV0.NONE;
        c.editable = true;
      });
    }
    return checkBox;
  }
}
